// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** Mixins **/
/** Vars (common) **/
/** app colors **/
/** Vars (MuiAlert) **/
/** main classes **/
.otp_old-container__CdQJp {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  position: relative;
  width: 100%;
}
.otp_old-container__CdQJp.otp_wrap__I8XL2 {
  flex-wrap: wrap;
}
.otp_old-container__CdQJp .otp_box__S3oXe.otp_col__GuDAD {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 0 10px;
}
.otp_old-container__CdQJp .otp_box__S3oXe.otp_col__GuDAD > div {
  width: 100%;
}
.otp_old-container__CdQJp .otp_box__S3oXe.otp_row__cUV7c {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
}
.otp_old-container__CdQJp form {
  padding: 20px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  position: relative;
  flex-wrap: wrap;
  width: 100%;
}
.otp_old-container__CdQJp form > .otp_box__S3oXe.otp_col__GuDAD {
  flex-basis: 33.33%;
}
@media screen and (min-width: 2560px) {
  .otp_old-container__CdQJp form > .otp_box__S3oXe.otp_col__GuDAD {
    flex-basis: 0%;
    margin-right: 2em;
  }
}

@media screen and (max-width: 580px) {
  .otp_old-container__CdQJp, .otp_col__GuDAD, form {
    padding: 5px;
  }
}
@media screen and (max-width: 450px) {
  .otp_old-container__CdQJp, .otp_col__GuDAD, form {
    padding: 0px;
  }
}
.otp_text-overflow-hidden__5PIj3 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.otp_icon__k6ThK {
  color: var(--accent-color);
}

.otp_richtext-output-wrap__sz99F .otp_se-video-container__mThr\\+ figure {
  padding-bottom: 0 !important;
}

.otp_otpWrapper__1XqcB {
  padding-bottom: 24px;
  padding-top: 24px;
}

.otp_otpInputWrapper__8Uzdn {
  gap: 8px;
}

.otp_otpInput__jE\\+r1 {
  width: 50px !important;
  height: 50px !important;
  background: #2F2F2F;
  border-radius: 8px;
  border-color: transparent;
  color: white;
  text-align: center;
  font-size: 20px;
}`, "",{"version":3,"sources":["webpack://./src/sass/_settings.sass","webpack://./src/components/common/OtpInput/otp.module.sass"],"names":[],"mappings":"AAAA,aAAA;AAeA,oBAAA;AAgBA,iBAAA;AA0BA,sBAAA;AAGA,mBAAA;AACA;EA3DE,aAAA;EACA,mBA4DM;EA3DN,8BA2DW;EA1DX,uBA0D0B;EAC1B,kBAAA;EACA,WAAA;ACrDF;ADsDE;EACE,eAAA;ACpDJ;ADsDI;EAnEF,aAAA;EACA,sBAmEU;EAlEV,2BAkEkB;EAjElB,uBAiE8B;EAC1B,eAAA;ACjDN;ADkDM;EACE,WAAA;AChDR;ADiDI;EAxEF,aAAA;EACA,mBAwEU;EAvEV,2BAuEe;EAtEf,uBAsE2B;EACvB,WAAA;AC5CN;AD6CE;EACE,aAjDK;EA3BP,aAAA;EACA,mBA4EQ;EA3ER,2BA2Ea;EA1Eb,uBA0EyB;EACvB,kBAAA;EACA,eAAA;EACA,WAAA;ACxCJ;ADyCI;EACE,kBAAA;ACvCN;ADwCM;EAFF;IAGI,cAAA;IACA,iBAAA;ECrCN;AACF;;ADsCA;EAEE;IACE,YAFO;EClCT;AACF;ADoCA;EAEE;IACE,YAFO;ECjCT;AACF;ADoCA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AClCF;;ADoCA;EACE,0BAtFO;ACqDT;;ADqCI;EACE,4BAAA;AClCN;;AAzEA;EACI,oBAAA;EACA,iBAAA;AA4EJ;;AA3EA;EACI,QAAA;AA8EJ;;AA7EA;EACI,sBAAA;EACA,uBAAA;EACA,mBDMG;ECLH,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AAgFJ","sourcesContent":["/** Mixins **/\n=flex($der, $justy, $align)\n  display: flex\n  flex-direction: $der\n  justify-content: $justy\n  align-items: $align\n\n=shadow()\n  box-shadow: -5px 5px 10px 0px rgba(#000, .35)\n\n=staticHeight($height)\n  min-height: $height\n  max-height: $height\n  height: $height\n\n/** Vars (common) **/\n$main: #2F2F2F\n$main_background: #191818\n$accent: var(--accent-color)\n$accent_text: var(--accent-text-color)\n$accent_r: var(--accent-color-r)\n$accent_g: var(--accent-color-g)\n$accent_g10: var(--accent-color-g10)\n$accent_b: var(--accent-color-b)\n$text: #cecece\n$error: #f44336\n$success: rgb(102, 187, 106)\n$container_background_color: #1B1B1B\n$container_item_background_color: #212121\n$gutter: 20px\n\n/** app colors **/\n$soft_teal: #84aaaf\n$fiery_red: #ff3131\n$muted_red: #e85a4f\n$app_red: #B83336\n$soft_creamy: #f5e8dd\n$light_gray: #535353\n$golden_yellow: #ffc107\n$orange: #ffa725\n$app_orange: #DB890E\n$warm_orange: #e3a869\n$faded_pink: #d69fa2\n$purple: #8868a3\n$app_purple: #7E51A3\n$light_blue: #79a8d1\n$app_green: #16962F\n$retro_green: #4a7c59\n$deep_blue: #406ca8\n\n$main_block_top_padding: 130px\n$main_block_top_padding_s: 70px\n$header_height: 120px\n$sidebar_width: 320px\n\n$table_row_height: 55px\n\n/** Vars (MuiAlert) **/\n$MuiAlert_main_color: rgb(166, 213, 250)\n\n/** main classes **/\n.old-container\n  //padding: $gutter\n  +flex(row, space-between, flex-start)\n  position: relative\n  width: 100%\n  &.wrap\n    flex-wrap: wrap\n  .box\n    &.col\n      +flex(column, flex-start, flex-start)\n      padding: 0 calc($gutter/2)\n      > div\n        width: 100%\n    &.row\n      +flex(row, flex-start, flex-start)\n      width: 100%\n  form\n    padding: $gutter\n    +flex(row, flex-start, flex-start)\n    position: relative\n    flex-wrap: wrap\n    width: 100%\n    > .box.col\n      flex-basis: 33.33%\n      @media screen and ( min-width: 2560px )\n        flex-basis: 0%\n        margin-right: 2em\n\n@media screen and ( max-width: 580px )\n  $gutter: 5px\n  .old-container, .col, form\n    padding: $gutter\n@media screen and ( max-width: 450px )\n  $gutter: 0px\n  .old-container, .col, form\n    padding: $gutter\n\n.text-overflow-hidden\n  overflow: hidden\n  text-overflow: ellipsis\n  white-space: nowrap\n\n.icon\n  color: $accent\n\n.richtext-output-wrap\n  .se-video-container\n    figure\n      padding-bottom: 0 !important\n","@import '../../../sass/settings'\n\n.otpWrapper\n    padding-bottom: 24px\n    padding-top: 24px\n.otpInputWrapper\n    gap: 8px\n.otpInput\n    width: 50px!important\n    height: 50px!important\n    background: $main\n    border-radius: 8px\n    border-color: transparent\n    color: white\n    text-align: center\n    font-size: 20px\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"old-container": `otp_old-container__CdQJp`,
	"wrap": `otp_wrap__I8XL2`,
	"box": `otp_box__S3oXe`,
	"col": `otp_col__GuDAD`,
	"row": `otp_row__cUV7c`,
	"text-overflow-hidden": `otp_text-overflow-hidden__5PIj3`,
	"icon": `otp_icon__k6ThK`,
	"richtext-output-wrap": `otp_richtext-output-wrap__sz99F`,
	"se-video-container": `otp_se-video-container__mThr+`,
	"otpWrapper": `otp_otpWrapper__1XqcB`,
	"otpInputWrapper": `otp_otpInputWrapper__8Uzdn`,
	"otpInput": `otp_otpInput__jE+r1`
};
export default ___CSS_LOADER_EXPORT___;
